import React, { useEffect, useState } from "react";
import { Modal, Button, Breadcrumb, Row, Col, Input, message } from "antd";
import BreadcrumbArrow from "../../assets/images/breadcrumb-image-arrow.svg";
import CheckImage from "../../assets/images/right-check-icon.svg";
import BidImage from "../../assets/images/leaderboard-profile.jpg";
import SeacureImage from "../../assets/images/seacure-icon.svg";
import Main from "../../components/layout/Main";
import { Navigate, useNavigate } from "react-router";
import { convertSecondToHours, isValidUrl } from "../../helper/functions";
import { useAuction } from "../../context/AuctionContext";
import { useParams } from "react-router";
import CommonBreadcrumb from "../../components/BreadCrumb";

const AuctionDetail = () => {
  const [open, setOpen] = useState(false);
  const { loadBids, placeBid, loadAuctionById } = useAuction();
  const [bids, setBids] = useState([]);
  const [auction, setAuction] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();

  // Bid flow states
  const [step, setStep] = useState(0);
  const [bidAmount, setBidAmount] = useState();
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setStep(0);
    setBidAmount();
    setOpen(false);
  };

  // Handle bid amount submission
  const handleBidAmountSubmit = () => {
    if (!bidAmount || bidAmount <= 0) {
      message.error("Please enter a valid bid amount");
      return;
    }
    if (bidAmount <= auction?.highestBidAmount) {
      message.error("Bid amount must be higher than current highest bid");
      return;
    }
    setStep(1);
  };

  // Handle insurance payment
  const handleInsurancePayment = async () => {
    setLoading(true);
    try {
      // Simulate insurance payment API call
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setStep(2);
    } catch (error) {
      message.error("Insurance payment failed");
    } finally {
      setLoading(false);
    }
  };

  // Handle final bid placement
  const handlePlaceBid = async () => {
    setLoading(true);
    try {
      const response = await placeBid(auction?._id, Number(bidAmount));
      if (response.success) {
        setStep(3);
        // Refresh bids list
        getBids();
      }
    } catch (error) {
      message.error("Failed to place bid. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // get bids
  const getBids = async () => {
    try {
      const response = await loadBids(id);
      setBids(response.data.items);
    } catch (error) {
      console.log(error);
    }
  };

  // get single auction by id
  const fetchAuction = async (id) => {
    try {
      const response = await loadAuctionById(id);
      if (response.success) {
        setAuction(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getBids();
  }, []);

  useEffect(() => {
    fetchAuction(id);
  }, [id]);

  console.log("auction in auction-->", auction);
  console.log("bids in auction--->", bids);

  return (
    <>
      <Main>
        <CommonBreadcrumb
          items={[
            { title: "Home", url: "/home" },
            { title: "Auctions", url: "/auctions" },
            { title: "Auction Detail" },
          ]}
        />
        <section className="product-detail-section">
          <div className="product-detail-main-box">
            <div className="product-full-image">
              {auction.images?.length > 0 && (
                <img
                  src={auction.images[0]}
                  alt={auction.itemName || "auction"}
                />
              )}
            </div>
            <div className="product-detail-main-page">
              <div className="pruduct-detail-headding auctions-details">
                <h5>{auction?.itemName} </h5>
                <div className="offer-time">
                  <h6>
                    {" "}
                    Ends in {convertSecondToHours(auction?.remainingTime)}{" "}
                  </h6>
                </div>
              </div>
              <div className="product-detail-menus">
                <ul>
                  <li>
                    <h6>Current Highest Bid</h6>
                    <h4>{auction?.currentHighestBid} Tokens</h4>
                  </li>
                </ul>
              </div>
              <div className="product-description">
                <strong>Description</strong>
                <p>{auction?.itemDescription}</p>
              </div>
              <div className="bid-action-buttons">
                <Input
                  className="bid-input-inn"
                  placeholder="Enter bid amount"
                  min={auction?.highestBidAmount + 1}
                  value={bidAmount}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9]/g, ""); // सिर्फ़ digits allow
                    setBidAmount(value);
                  }}
                />
                <Button
                  className="buy-now bid-now-button"
                  onClick={() => {
                    if (!bidAmount || bidAmount <= 0) {
                      message.error("Please enter a valid bid amount");
                      return;
                    }
                    if (bidAmount <= auction?.highestBidAmount) {
                      message.error(
                        "Bid amount must be higher than current highest bid"
                      );
                      return;
                    }
                    setStep(1);
                  }}
                  disabled={
                    !bidAmount || bidAmount <= auction?.highestBidAmount
                  }
                >
                  Place Bid
                </Button>
              </div>
            </div>
          </div>
        </section>
        <section className="product-detail-list-section">
          <div className="orange-header">Bid History</div>
          <Row>
            <Col span={24} lg={10}>
              <div className="bid-history-box">
                <ul>
                  {bids.length === 0
                    ? "No history available"
                    : bids?.map((bid, index) => {
                        return (
                          <li className="bid-listing-main" key={index}>
                            <div className="bid-list-iconname">
                              <img
                                src={
                                  isValidUrl(bid?.user?.profilePic)
                                    ? bid?.user?.profilePic
                                    : BidImage
                                }
                              />
                              <h6>{bid?.user?.name}</h6>
                            </div>
                            <div className="bid-pricing">
                              {bid?.amount} Tokens
                            </div>
                          </li>
                        );
                      })}
                </ul>
              </div>
            </Col>
          </Row>
        </section>
      </Main>

      {/* Bid Amount Confirmation Modal */}
      <Modal
        className="order-success-modal"
        width={452}
        open={open}
        footer={null}
        centered
        onCancel={() => setOpen(false)}
      >
        <div className="modal-content">
          <div className="insurance-modal-headding">
            <div className="modal-icon">
              <img src={BidImage} alt="bid" />
            </div>
            <h3>Confirm Your Bid</h3>
            <p>You are about to place a bid for:</p>
          </div>
          <div className="amount-insurance-text">
            <h6>Item:</h6>
            <h4>{auction?.itemName}</h4>
            <h6>Your Bid Amount:</h6>
            <h2>{bidAmount} Tokens</h2>
            <h6>Current Highest Bid:</h6>
            <h3>{auction?.highestBidAmount} Tokens</h3>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              type="default"
              className="light-button"
              onClick={() => setOpen(false)}
              style={{ flex: 1 }}
            >
              Cancel
            </Button>
            <Button
              type="default"
              className="Fill-button"
              onClick={handleBidAmountSubmit}
              style={{ flex: 1 }}
            >
              Continue to Insurance
            </Button>
          </div>
        </div>
      </Modal>

      {/* Insurance Required */}
      <Modal
        className="order-success-modal"
        width={452}
        open={step === 1}
        footer={null}
        centered
        onCancel={() => setStep(0)}
      >
        <div className="modal-content">
          <div className="insurance-modal-headding">
            <div className="modal-icon">
              <img src={SeacureImage} alt="shield" />
            </div>
            <h3>Insurance Required</h3>
            <p>
              To place a bid, you need to pay the one-time auction insurance
              fee.
            </p>
          </div>
          <div className="amount-insurance-text">
            <h6>Insurance Fee:</h6>
            <h2 style={{ color: "white" }}>
              {auction?.insuranceFee || 100} Tokens
            </h2>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              type="default"
              className="Fill-button"
              onClick={handleInsurancePayment}
              loading={loading}
              style={{ flex: 1 }}
            >
              Pay Insurance Now
            </Button>
          </div>
        </div>
      </Modal>

      {/* Insurance Done */}
      <Modal
        className="order-success-modal"
        width={452}
        open={step === 2}
        footer={null}
        centered
        onCancel={() => setStep(0)}
      >
        <div className="modal-content">
          <div className="insurance-modal-headding">
            <div className="modal-icon">
              <img src={CheckImage} alt="check" />
            </div>
            <h3>Insurance Completed</h3>
            <p>Your insurance payment has been processed successfully.</p>
            <p>You can now place your bid.</p>
          </div>
          <div className="amount-insurance-text">
            <h6>Ready to place bid for:</h6>
            <h2>{bidAmount} Tokens</h2>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              type="default"
              className="Fill-button"
              onClick={handlePlaceBid}
              loading={loading}
              style={{ flex: 1 }}
            >
              Place Order
            </Button>
          </div>
        </div>
      </Modal>

      {/* Bid Placed */}
      <Modal
        className="order-success-modal"
        width={452}
        open={step === 3}
        footer={null}
        centered
        onCancel={handleClose}
      >
        <div className="modal-content">
          <div className="insurance-modal-headding">
            <div className="modal-icon">
              <img src={CheckImage} alt="check" />
            </div>
            <h3>Bid Placed Successfully</h3>
            <p>
              Your bid of {bidAmount} Tokens has been placed for{" "}
              {auction?.itemName}.
            </p>
            <p>
              You'll be notified if you're outbid or if you win the auction.
            </p>
          </div>
          <div className="bid-placed-footer">
            <Button
              type="default"
              className="Fill-button"
              onClick={handleClose}
            >
              Ok
            </Button>
            <Button
              type="default"
              className="light-button"
              onClick={() => navigate("/my-bids")}
            >
              View My Bids
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AuctionDetail;
